import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/routes/app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SharedModule } from './modules/shared/shared.module';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './http-interceptors/auth.interceptor';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NonAdminGuard } from './Guards/non-admin.guard';
import { AdminGuard } from './Guards/admin.guard';
import { SuccessModalComponent } from './components/dialogs/add-customer-printer-dialog/success-modal/success-modal.component';
import { AddDeviceDialogComponent } from './components/dialogs/add-device-dialog/add-device-dialog.component';
import { CaseActivityLogComponent } from './components/dialogs/case-activity-log/case-activity-log.component';
import { SuccessModelComponent } from './components/dialogs/request-preview/success-model/success-model.component';
import { ShowQrComponent } from './pages/show-qr/show-qr.component';
import { IpWhitelistComponent } from './components/printos-admin-dialogs/ip-whitelist/ip-whitelist.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from './paginator-intl';
import { UserRoleGuard } from './Guards/user-role.guard';
import { CommonModule } from '@angular/common';
import { PopscreenComponent } from './components/dialogs/popscreen/popscreen.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}
@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    SuccessModalComponent,
    CaseActivityLogComponent,
    SuccessModelComponent,
    ShowQrComponent,
    IpWhitelistComponent,
    PopscreenComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
    },
    NonAdminGuard,
    AdminGuard,
    UserRoleGuard
  ],
  exports : [
    SharedModule,
    PopscreenComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
